import { categories } from '@/mocks/categories';

export default function CategoryButtons() {
  return (
    <section className="w-full py-10 md:py-14 px-4 md:px-6">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-8">
          <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-950 mb-2">
            Shop by Category
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            Browse our curated categories and discover the best products from our main store at kaspreadsheet.com
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-3">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex flex-col items-center gap-2 bg-background-50 border border-background-200/70 rounded-xl px-3 py-5 hover:border-accent-300 hover:bg-accent-50/50 transition-all duration-200 cursor-pointer"
            >
              <div className="w-12 h-12 rounded-xl bg-accent-100 flex items-center justify-center group-hover:bg-accent-200 transition-colors">
                <i className={`${cat.icon} text-accent-600 text-lg w-5 h-5 flex items-center justify-center`}></i>
              </div>
              <span className="text-xs font-medium text-foreground-700 group-hover:text-foreground-950 text-center leading-tight whitespace-nowrap">
                {cat.name}
              </span>
            </a>
          ))}
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mt-10">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="whitespace-nowrap inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-white font-semibold px-8 py-3 rounded-full transition-all duration-300 hover:scale-105 cursor-pointer text-sm"
          >
            <i className="ri-shopping-bag-line w-5 h-5 flex items-center justify-center"></i>
            Superbuy Sheet
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="whitespace-nowrap inline-flex items-center gap-2 bg-secondary-500 hover:bg-secondary-600 text-white font-semibold px-8 py-3 rounded-full transition-all duration-300 hover:scale-105 cursor-pointer text-sm"
          >
            <i className="ri-flashlight-line w-5 h-5 flex items-center justify-center"></i>
            Buy It Now
          </a>
        </div>
      </div>
    </section>
  );
}